import { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const sectionClass = "mb-10";
  const h2Class = "text-2xl font-semibold text-[#1a1a1a] mb-4";
  const pClass = "text-gray-500 text-sm leading-relaxed mb-3";
  const font = { fontFamily: "'Montserrat', sans-serif" };

  return (
    <div className="min-h-screen pt-24 pb-20 bg-[#f7f6f3]" data-testid="privacy-page">
      <div className="container mx-auto px-4 md:px-8 max-w-3xl">
        <div className="text-center mb-14">
          <h1
            className="text-4xl md:text-5xl font-bold tracking-tight text-[#1a1a1a] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Privacy Policy
          </h1>
          <p className="text-gray-500 text-sm" style={font}>
            Last updated: December 2025
          </p>
        </div>

        <div className="rounded-2xl bg-white border border-gray-200 p-8 md:p-12 shadow-sm" style={font}>
          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>1. Introduction</h2>
            <p className={pClass}>
              Global Citizenship Consulting ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
            </p>
          </div>

          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>2. Information We Collect</h2>
            <p className={pClass}>
              <strong className="text-white">Personal Data:</strong> When you fill out our contact form or download resources, we may collect your name, email address, phone number, and any message you provide.
            </p>
            <p className={pClass}>
              <strong className="text-white">Usage Data:</strong> We automatically collect certain information about your device and how you interact with our website, including IP address, browser type, pages visited, and time spent.
            </p>
            <p className={pClass}>
              <strong className="text-white">Cookies:</strong> We use cookies and similar tracking technologies to enhance your browsing experience and analyze website traffic.
            </p>
          </div>

          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>3. How We Use Your Information</h2>
            <p className={pClass}>We use the information we collect to:</p>
            <ul className="list-disc list-inside text-gray-400 text-sm space-y-1 mb-3 ml-4">
              <li>Respond to your inquiries and provide our consulting services</li>
              <li>Send you relevant resources, newsletters, and updates</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>4. Third-Party Services</h2>
            <p className={pClass}>
              We use HubSpot as our CRM platform to manage contact information. Your data may be stored on HubSpot's servers. We also use analytics tools to understand website usage patterns.
            </p>
          </div>

          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>5. Data Security</h2>
            <p className={pClass}>
              We implement industry-standard security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>6. Your Rights</h2>
            <p className={pClass}>
              You have the right to access, correct, or delete your personal data. You may opt out of marketing communications at any time. To exercise these rights, please contact us at contact@globalcitizenconsult.com.
            </p>
          </div>

          <div className={sectionClass}>
            <h2 className={h2Class} style={{ fontFamily: "'Playfair Display', serif" }}>7. Contact Us</h2>
            <p className={pClass}>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className={pClass}>
              <strong className="text-white">Global Citizenship Consulting</strong><br />
              Email: contact@globalcitizenconsult.com<br />
              Website: www.globalcitizenconsult.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
